<template>
  <div class="login-container">
    <div class="login-container-content">
      <v-card outlined>
        <v-col flex class="sm12">
          <v-card-title class="justify-center controlled-font">
            {{ loginText }}
          </v-card-title>
          <div class="actions">
            <RadioButtons
              :options="birthDateOptions"
              @change="birthDateSelected"
              v-show="dobState === 'B'"
              ref="birthDates"
            >
            </RadioButtons>
            <RadioButtons
              :options="ageOptions"
              @change="ageSelected"
              v-show="dobState === 'A'"
              ref="ages"
            >
            </RadioButtons>
          </div>
          <div
            v-if="errorMessage"
            class="red--text mx-auto text-center controlled-font"
          >
            {{ normailizedErrorMessage }}
          </div>
        </v-col>
      </v-card>
    </div>
  </div>
</template>

<script>
import RadioButtons from "../components/ui/RadioButtons.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    RadioButtons,
  },
  data() {
    return {
      selectedBirthDay: null,
      selectedAge: null,
      dobState: "B",
      display: true,
      errorMessage: "",
    };
  },
  methods: {
    ...mapActions([
      "verifyDOBLogin",
      "SetPage",
      "startTestingSession",
      "setIdleTimeOut",
    ]),
    birthDateSelected(birthDate) {
      //handle lockout//
      if (this.accountLocked) {
        return;
      }

      console.log(birthDate);
      this.errorMessage = "";
      this.selectedBirthDay = birthDate;
      this.dobState = "A";
    },
    async ageSelected(age) {
      //handle lockout//
      if (this.accountLocked) {
        return;
      }

      this.selectedAge = age;
      //Verify Login//
      console.log(age);
      try {
        await this.verifyDOBLogin({
          birthDate: this.selectedBirthDay,
          age: String(age),
        });
        this.startTestingSession();
      } catch (error) {
        if (typeof error === "string") {
          this.errorMessage = error;
          this.dobState = "B";
          this.clearSelections();
        }
      }
    },
    clearSelections() {
      this.selectedBirthDay = null;
      this.selectedAge = null;
      this.$refs.birthDates.clearSelection();
      this.$refs.ages.clearSelection();
    },
  },
  computed: {
    ...mapGetters(["siteText", "birthDates", "ages", "pages"]),
    birthDateOptions() {
      let bdOptions = [];
      this.birthDates.map((value) => {
        bdOptions.push({ key: value, text: value });
      });

      return bdOptions;
    },
    ageOptions() {
      let options = [];
      this.ages.map((value) => {
        options.push({ key: value, text: value });
      });
      return options;
    },
    loginText() {
      return this.dobState === "B"
        ? this.siteText.ui.dobSelectBirthdate
        : this.siteText.ui.dobSelectAge;
    },
    normailizedErrorMessage() {
      let message = this.errorMessage;
      if (message === "InvalidLogin") {
        message = this.siteText.ui.invalidLoginCredentials;
      }

      if (message === "LockedOut") {
        message = this.siteText.ui.accountLockedOut;
      }
      return message;
    },
    accountLocked() {
      return this.errorMessage === "LockedOut";
    },
  },
};
</script>

<style scoped>
.actions {
  min-width: 500px;
  width: 100%;
  margin: auto;
}

@media screen and (max-width: 500px) {
  .actions {
    min-width: 350px;
  }
}

.login-container {
  transform-origin: center center;
  max-height: 90%;
}

.login-container-content {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
}
</style>
